<h2 mat-dialog-title> Related Project Codes Found</h2>
<div *ngIf="selectedProjectCodes.length == 0" style="margin: 20px;text-align: left;" class="btn btn-warning">
    Please select at least one project code.
</div>
<mat-dialog-content>
    <mat-selection-list [(ngModel)]="selectedProjectCodes">
        <mat-list-option *ngFor="let code of data.projectCodes" [value]="code">
            {{ code }}
        </mat-list-option>
    </mat-selection-list>
</mat-dialog-content>



<mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" color="primary">Cancel</button>
    <button mat-raised-button color="primary" (click)="submit()" [disabled]="selectedProjectCodes.length === 0">
        Submit
    </button>
</mat-dialog-actions>